import { Col, Grid, Row } from "@codat/orchard-ui";
import classNames from "classnames";
import React, { lazy } from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import Page from "components/Page";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";

import styles from "./AccountSetings.module.css";

const RemoteAccountSettingsApp = lazy(
  () => import("codat-user-management/AccountSettings")
);

const AccountSettings = () => {
  return (
    <Page>
      <React.Suspense
        fallback={
          <Grid className={classNames(styles.loading)}>
            <Row>
              <Col size={12}>
                <PageLoadingSkeleton />
              </Col>
            </Row>
          </Grid>
        }
      >
        <ErrorBoundary>
          <RemoteAccountSettingsApp />
        </ErrorBoundary>
      </React.Suspense>
    </Page>
  );
};

export default AccountSettings;
